import axios from "axios"

export function setTokenHeader(token) {
  if(token) {
    axios.defaults.headers.common["Authorization"] = `${token}`
  } else {
    delete axios.defaults.headers.common["Authorization"]
  }
}

export function apiCall(method,url,data){
  return new Promise((resolve,reject) => {
    return axios({method,url,data})
    .then(res => {
      return resolve(res.data)
    })
    .catch(err=> {
      return reject(err.response.data.error)
    })
  })
}



// WEBPACK FOOTER //
// ./src/services/api.js